import { render } from "./SlideFour.vue?vue&type=template&id=0db303a6&scoped=true"
import script from "./SlideFour.vue?vue&type=script&lang=js"
export * from "./SlideFour.vue?vue&type=script&lang=js"

import "./SlideFour.vue?vue&type=style&index=0&id=0db303a6&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0db303a6"]])

export default __exports__